module.exports = __webpack_public_path__ + "static/media/mob-paintathon-main.db25f479.jpg";